import { AdminPageContent } from "@/components/admin";
import { Outlet } from "react-router";

const AdminUsersLayout = () => {
    return (
        <AdminPageContent>
            <Outlet />
        </AdminPageContent>
    );
};

export default AdminUsersLayout;
